import { render, staticRenderFns } from "./JobTypeContainer.vue?vue&type=template&id=67672a2d&lang=pug"
import script from "./JobTypeContainer.vue?vue&type=script&lang=ts"
export * from "./JobTypeContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports